export const COLORS = [
  { key: "yellow", label: "Yellow", dot: "#F2CF4A", bg: "rgba(242, 207, 74, 0.45)" },
  { key: "green", label: "Green", dot: "#8FD19E", bg: "rgba(143, 209, 158, 0.45)" },
  { key: "blue", label: "Blue", dot: "#8DBDF0", bg: "rgba(141, 189, 240, 0.45)" },
  { key: "pink", label: "Pink", dot: "#F2A3BF", bg: "rgba(242, 163, 191, 0.45)" },
  { key: "orange", label: "Orange", dot: "#F4AE6B", bg: "rgba(244, 174, 107, 0.45)" },
];
export const colorOf = (key) => COLORS.find((c) => c.key === key) || COLORS[0];

const keyEl = (node) => (node?.nodeType === 3 ? node.parentElement : node)?.closest?.("[data-hl-key]") || null;

/* Read the current DOM selection as {start:{key,offset}, end:{key,offset}, text, rect} relative to keyed containers inside `root`. */
export function readSelection(root) {
  const sel = window.getSelection();
  if (!root || !sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
  const range = sel.getRangeAt(0);
  const startEl = keyEl(range.startContainer), endEl = keyEl(range.endContainer);
  if (!startEl || !endEl || !root.contains(startEl) || !root.contains(endEl)) return null;
  const off = (el, node, offset) => { const r = document.createRange(); r.selectNodeContents(el); r.setEnd(node, offset); return r.toString().length; };
  const text = sel.toString().replace(/\s+/g, " ").trim();
  if (text.length < 2) return null;
  return { start: { key: startEl.dataset.hlKey, offset: off(startEl, range.startContainer, range.startOffset) }, end: { key: endEl.dataset.hlKey, offset: off(endEl, range.endContainer, range.endOffset) }, text, rect: range.getBoundingClientRect() };
}

/* Split `text` (container `key`, within ordered `keys`) into segments painted by `highlights`. */
export function segments(text, key, keys, highlights) {
  const idx = (k) => keys.indexOf(String(k));
  const ki = idx(key);
  const covering = [];
  for (const h of highlights || []) {
    const si = idx(h.start.key), ei = idx(h.end.key);
    if (si < 0 || ei < 0 || ki < si || ki > ei) continue;
    const from = ki === si ? Math.min(h.start.offset, text.length) : 0;
    const to = ki === ei ? Math.min(h.end.offset, text.length) : text.length;
    if (to > from) covering.push({ from, to, h });
  }
  if (!covering.length) return [{ text, h: null }];
  const points = [...new Set([0, text.length, ...covering.flatMap((c) => [c.from, c.to])])].sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i < points.length - 1; i++) {
    const a = points[i], b = points[i + 1];
    if (b <= a) continue;
    const hits = covering.filter((c) => c.from <= a && c.to >= b);
    const top = hits.length ? hits.reduce((x, y) => (x.h.created_at > y.h.created_at ? x : y)).h : null;
    out.push({ text: text.slice(a, b), h: top });
  }
  return out;
}

export const bibleLabel = (book, chapter, s, e) => `${book} ${chapter}:${s}${e && e !== s ? `-${e}` : ""}`;
